// Photo and Video Modals
import _ from 'underscore';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

let modalImageTemplate;

let modalVideoTemplate;

const removeModal = () => {
  const modal = document.querySelector('.modal');
  const modalBackdrop = document.querySelector('.modal-backdrop');
  const closeButton = document.querySelector('.btn-close');
  if (modal.parentElement) {
    modal.parentElement.removeChild(modal);
    if (modalBackdrop) {
      modalBackdrop.parentElement.removeChild(modalBackdrop);
    }
    document.removeEventListener('click', removeModal);
    closeButton.removeEventListener('click', removeModal);
  }
};

const modalHandler = () => {
  const modal = document.querySelector('.modal');
  const modalContent = document.querySelector('.modal-content');
  const closeButton = document.querySelector('.btn-close');
  if (modal && modalContent) {
    document.addEventListener('click', removeModal);
    modalContent.addEventListener('click', event => event.stopPropagation());
    closeButton.addEventListener('click', removeModal);
    closeButton.focus();
  }
};

const addModal = (self) => {
  if (self.parentElement.classList.contains('image-wrapper')) {
    const { props, imageUrl } = self.parentElement.dataset;
    console.log(props, imageUrl);
    const [prop0, prop1] = props.split(',');
    if (prop0 === 'Image') {
      const templateProps = {
        newId: self.parentElement.id.split('-')[2],
        productLineName: prop1,
        productDescription: self.parentElement.getAttribute('data-product-description'),
        productLineId: self.parentElement.getAttribute('data-product-line-id'),
        productLineURL: self.parentElement.getAttribute('data-product-url'),
        modalLabel: self.parentElement.getAttribute('data-modal-label'),
        imageStory: self.parentElement.getAttribute('data-image-story'),
        imageSrc: imageUrl,
        imageAlt: self.parentElement.querySelector('.poster-image').getAttribute('alt'),
      };

      const hasVisualizerLink = self.parentElement.querySelector('.gallery-link .swatchcard--viewdetail .visualizer-link');
      const hasSwatchButtton = self.parentElement.parentElement.querySelector('.swatchcard--content .swatchbutton');
      console.log(hasSwatchButtton);// remove after testing
      console.log(hasVisualizerLink);// remove after testing
      if (hasVisualizerLink) {
        templateProps.visualizerUrl = self.parentElement.querySelector('.gallery-link .swatchcard--viewdetail .visualizer-link').getAttribute('href');
        templateProps.visualizerModelId = self.parentElement.getAttribute('data-visualizer-model-id');
        templateProps.visualizerProgramFamilyName = '';
        templateProps.colorNumber = self.parentElement.getAttribute('data-visualizer-color-number');
      }

      const compiled = modalImageTemplate(templateProps);
      const d = document.createElement('div');
      d.innerHTML = compiled;

      const buttonContainer = document.createElement('div');
      buttonContainer.classList.add('d-flex', 'justify-content-around', 'flex-column', 'flex-md-row', 'w-100', 'm-3');
      d.querySelector('.row-eq-height').appendChild(buttonContainer);

      if (hasSwatchButtton) {
        const swatchButton = document.createElement('button');
        swatchButton.classList.add('btn', 'btn-secondary', 'col-10', 'col-md-5');
        if (hasVisualizerLink) {
          swatchButton.classList.add('mb-3', 'mb-md-0');
        }
        swatchButton.innerHTML = 'Add Free Swatch';
        swatchButton.addEventListener('click', () => {
          hasSwatchButtton.click();
          removeModal();
        });
        buttonContainer.appendChild(swatchButton);
      }
      if (hasVisualizerLink) {
        const visualizerButton = document.createElement('a');
        visualizerButton.href = templateProps.visualizerUrl;
        visualizerButton.classList.add('btn', 'btn-secondary', 'btn-inverted', 'col-10', 'col-md-5');
        visualizerButton.addEventListener('click', e => e.stopPropagation());
        visualizerButton.innerHTML = 'View in Visualizer';

        buttonContainer.appendChild(visualizerButton);
      }
      self.parentElement.appendChild(d.firstChild);
      self.parentElement.firstElementChild.setAttribute('data-target', `#modal-${templateProps.newId}`);
      setTimeout(() => (modalHandler()), 300);
    }
  }
  if (self.parentElement.classList.contains('video-wrapper')) {
    const { props } = self.parentElement.dataset;
    const [prop0, prop1] = props.split(',');
    if (prop0 === 'Video') {
      const templateProps = {
        newId: self.parentElement.id.split('-')[2],
        productLineName: prop1,
        videoTitle: self.parentElement.getAttribute('data-video-title'),
        videoDescription: self.parentElement.getAttribute('data-video-description'),
        videoIframe: self.parentElement.getAttribute('data-video-iframe'),
      };
      const compiled = modalVideoTemplate(templateProps);
      const d = document.createElement('div');
      d.innerHTML = compiled;
      self.parentElement.appendChild(d.firstChild);
      self.parentElement.firstElementChild.setAttribute('data-target', `#modal-${templateProps.newId}`);
      setTimeout(() => (modalHandler()), 300);
    }
  }
};

const loadModal = (options) => {
  const {
    imageTemplate,
    videoTemplate,
    galleryModalSelector,
  } = options;

  modalImageTemplate = (imageTemplate ? _.template(imageTemplate) : null);
  modalVideoTemplate = (videoTemplate ? _.template(videoTemplate) : null);

  Array.prototype.map.call(document.querySelectorAll(galleryModalSelector), (item, index) => {
    item.parentElement.setAttribute('id', `modal-item-${index}`);
    item.addEventListener('click', (event) => {
      while (event.currentTarget.nextElementSibling) {
        event.currentTarget.parentElement.removeChild(event.currentTarget.nextElementSibling);
      }
      addModal(event.currentTarget);
    });
  });
};

// Initialize modal and set event listeners
const init = (options) => {
  loadModal(options);
  window.loadModal = loadModal;
};

export default {
  loadModal,
  init,
};
